import { ErrorHandler, Injectable, inject } from '@angular/core';
import {
  ErrorMonitoringService,
  RuntimeErrorMonitoringEvent,
} from './error-monitoring.service';

@Injectable()
export class GlobalErrorHandlerService implements ErrorHandler {
  private readonly errorMonitoringService = inject(ErrorMonitoringService);

  handleError(error: unknown): void {
    const event: RuntimeErrorMonitoringEvent = {
      source: 'global-error-handler',
      timestamp: new Date().toISOString(),
    };

    this.errorMonitoringService.captureRuntimeError(event, error);
  }
}
